import { useState, useCallback, useEffect, useRef } from "react"
import { toast } from "react-toastify"
import { debounce } from "lodash"
import axiosInstance from "../../../../services/axios-client"

const useListUser = () => {
    const [payload, setPayload] = useState([])
    const [file, setSelectedFile] = useState(null)
    const [fileInputKey, setFileInputKey] = useState(Date.now())
    const [page, setPage] = useState(1)
    const [totalPage, setTotalPage] = useState(1)
    const [loadingPagestate, setLoadingPage] = useState(false)

    const changePage = useCallback(async (page) => {
        setPage(page)
    }, [])

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setSelectedFile(file);
    };

    const clearFileInput = () => {
        setSelectedFile(null)
        setFileInputKey(Date.now())
    }

    const [limit, setLimit] = useState(10)
    const [filterName, setFilterName] = useState("")

    const setFilterNameUser = useCallback((e) => {
        setFilterName(e.target.value)
        setPage(1)
    }, [])

    const setFilterLimit = useCallback((data) => {
        setLimit(data)
        setPage(1)
    }, [])

    const debouncedGetUsersRef = useRef(
        debounce((page, limit, name) => {
            setLoadingPage(true)
            axiosInstance.get(`/auth/users?page=${page}&limit=${limit}&name=${name}`)
                .then(res => {
                    setPayload(res.data.data)
                    setTotalPage(res.data.paging.TotalPages)
                })
                .catch(error => {
                    if (error.response) {
                        toast.error(error?.response?.data?.status?.description)
                    } else if (error.message) {
                        toast.error(error.message)
                    } else {
                        toast.error(error)
                    }
                })
                .finally(() => {
                    setLoadingPage(false)
                })
        }, 800)
    ).current

    useEffect(() => {
        debouncedGetUsersRef(page, limit, filterName)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, limit, filterName])

    const getUsers = useCallback(async (page) => {
        try {
            setLoadingPage(true)
            let res = await axiosInstance.get(`/auth/users?page=${page}&limit=${limit}&name=${filterName}`)
            setPayload(res.data.data)
            setTotalPage(res.data.paging.TotalPages)
        } catch (error) {
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        } finally {
            setLoadingPage(false)
        }
    }, [limit, filterName])

    const [logs, setLogs] = useState()

    const postBulkUser = async (onSuccess) => {
        try {
            setLoadingPage(true)
            setLogs()
            const formData = new FormData();
            // console.log(file)
            formData.append("excelFile", file)
            let res = await axiosInstance.post('/auth/users/upload', formData)
            if (res.status === 200) {
                toast.success("Success Add User Data")
                clearFileInput()
                if (onSuccess) {
                    onSuccess()
                }
            }
            setLoadingPage(false)
        } catch (error) {
            setLoadingPage(false)
            if (error.response) {
                if (error?.response?.data?.status?.description) {
                    let data = error?.response?.data?.status?.description.split(",")
                    setLogs(data)
                }
                toast.warning("Check logs")
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    const postBulkPassword = async (onSuccess) => {
        try {
            setLoadingPage(true)
            const formData = new FormData();
            // console.log(file)
            formData.append("excelFile", file)
            let res = await axiosInstance.post('/auth/users/upload/password', formData)
            if (res.status === 200) {
                toast.success("Success Change User Password")
                clearFileInput()
                if (onSuccess) {
                    onSuccess()
                }
            }
            setLoadingPage(false)
        } catch (error) {
            setLoadingPage(false)
            if (error.response) {
                if (error?.response?.data?.status?.description) {
                    let data = error?.response?.data?.status?.description.split(",")
                    setLogs(data)
                }
                toast.warning("Check logs")
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    const generatePassword = async (id, onSuccess) => {
        try {
            setLoadingPage(true)
            let res = await axiosInstance.post(`/auth/users/generate-password/${id}`)
            if (res.status === 200) {
                toast.success("Success Generate Password")
                if (onSuccess) {
                    onSuccess()
                }
            }
            setLoadingPage(false)
        } catch (error) {
            setLoadingPage(false)
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    const deleteUser = async (id, onSuccess) => {
        try {
            setLoadingPage(true)
            let res = await axiosInstance.delete(`/auth/users/${id}`)
            if (res.status === 204) {
                toast.success("Success Delete User")
                if (onSuccess) {
                    onSuccess()
                }
            }
            setLoadingPage(false)
        } catch (error) {
            setLoadingPage(false)
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    return {
        payload,
        getUsers,
        fileInputKey,
        handleFileChange,
        postBulkUser,
        page,
        changePage,
        totalPage,
        generatePassword,
        deleteUser,
        setFilterNameUser,
        limit,
        filterName,
        setFilterLimit,
        logs,
        loadingPagestate,
        postBulkPassword,
    }
}

export default useListUser